export default function initAlert(): void {
    const $alertContainer = document.querySelectorAll<HTMLElement>('.js-alert');
    $alertContainer.forEach($container => {
        new Alert($container);
    });
}

class Alert {
    $el: HTMLElement | null | undefined;
    $closeBtn: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$closeBtn = $el?.querySelector('.js-close-alert');
        this.init();
    }

    init(): void {
        if (this.$el && this.$closeBtn) {
            this.$closeBtn?.addEventListener('click', this.closeAlert.bind(this));
        }
    }

    closeAlert(): void {
        this.$el?.classList.add('hidden');
        this.$closeBtn?.removeEventListener('click', this.closeAlert);
    }
}
